import { vars } from 'src/core/themes';
import styled from 'styled-components/macro';

export const Divider = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.colors.borderPrimary};
  width: 100%;
  padding-bottom: ${() => vars.spacing.sm};
`;
